import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-auto" }
const _hoisted_2 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_3 = { class: "bg-theme-green px-4 py-2 text-white" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex items-center content-center gap-2" }
const _hoisted_7 = { class: "bg-[#2B2C32] h-[520px] px-[16px] py-[16px] rounded-b-lg" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "w-full mt-5" }
const _hoisted_11 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectLocations = _resolveComponent("SelectLocations")!
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, { size: 'max-w-xl' }, {
    maincontent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex flex-col justify-start text-start" }, [
                _createElementVNode("h2", { class: "font-semibold truncate text-single-line break-all mb-0.5 text-xl leading-6 mt-0 ml-2" }, "Edit User")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"])),
                    class: "text-sm flex items-center justify-center text-center w-[100px] h-[44px] tracking-[0.15px] font-medium cursor-pointer hover:bg-white border border-white p-4 rounded hover:text-theme-green text-white ml-3"
                  }, "CANCEL"),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"])),
                    class: "text-sm flex items-center justify-center text-center w-[100px] h-[44px] tracking-[0.15px] font-medium cursor-pointer bg-white p-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white ml-3"
                  }, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("span", null, "SAVE", -1)
                  ]))])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass('input-wrapper ' + (_ctx.form.email.error_type))
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-xs mb-1" }, "Email*", -1)),
                _withDirectives(_createElementVNode("input", {
                  placeholder: "Email@address.com",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email.value) = $event)),
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['email']))),
                  class: "block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack",
                  type: "text"
                }, null, 544), [
                  [_vModelText, _ctx.form.email.value]
                ]),
                (_ctx.form.email.error_message)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "field-error label-text mt-1",
                      textContent: _toDisplayString(_ctx.form.email.error_message)
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: _normalizeClass('input-wrapper ' + (_ctx.form.locationId.error_type))
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-xs tracking-[0.4px]" }, "Locations", -1)),
                _createVNode(_component_SelectLocations, {
                  class: "bg-gray-black rounded relative",
                  modelValue: _ctx.form.locationId.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.locationId.value) = $event)),
                  options: _ctx.vg_locations,
                  placeholder: "Select all that apply"
                }, null, 8, ["modelValue", "options"]),
                (_ctx.form.locationId.error_message)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "field-error label-text mt-1",
                      textContent: _toDisplayString(_ctx.form.locationId.error_message)
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}